import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useCallback, useEffect, useState } from "react";
import { OutboundQueryTypes } from "../../Enums/OutboundQueryType";
import TrackingCodes from "../../Pages/OutboundFeedsPage/TrackingCodes";
import { addFeed, getAllFeedOptions, getOutboundFeeds, getStates } from "../../Services/API/OutboundFeeds";
import DropdownComponent from "../Dropdown/DropdownComponent";
import LoadingBar from "../LoadingBar/LoadingBar";
import { StyledTextField } from "../TextField/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
  textField: {
    "& .Mui-error": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.error.main,
    },
  },
}));

export default function OutboundFeedsModal({
  openModal,
  setData,
  setShowSignifier,
  setShowError,
  selectedClient,
}) {
  const classes = useStyles();

  const [showInputError, setShowInputError] = useState(false);
  const [trackingCodes, setTrackingCodes] = useState([{ name: "", value: "", isPassThrough: false }]);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [categories, setCategories] = useState([]);
  const [families, setFamilies] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [states, setStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("");
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [useCData, setUseCData] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [reqNumbers, setReqNumbers] = useState("");
  const [addProcessing, setAddProcessing] = useState(false);

  const convertDate = (date) => {
    const newDate = new Date(date).toLocaleDateString("en-US");
    return newDate;
  };

  const checkAllEntered = () => {
    if (name === "" || selectedTemplate === "") {
      return false;
    }
    return true;
  };

  const compare = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  const sort = useCallback((array, fieldName) => {
    array.sort((a, b) => {
      const order = compare(a[fieldName], b[fieldName]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
  }, []);

  const handleAddCode = () => {
    if (trackingCodes.length === 5) {
      return;
    }
    const items = Array.from(trackingCodes);
    items.push({ name: "", value: "", isPassThrough: false });

    setTrackingCodes(items);
  };

  const prepQueries = () => {
    const retVal = [];
    for (const i in selectedIndustry) {
      const query = {
        QueryTypeID: OutboundQueryTypes.Industry,
        Value: selectedIndustry[i].id,
      };
      retVal.push(query);
    }
    for (const i in selectedFamily) {
      const query = {
        QueryTypeID: OutboundQueryTypes.Family,
        Value: selectedFamily[i].id,
      };
      retVal.push(query);
    }
    for (const i in selectedCategories) {
      const query = {
        QueryTypeID: OutboundQueryTypes.Category,
        Value: selectedCategories[i].id,
      };
      retVal.push(query);
    }
    if (selectedCountry !== "" && selectedCountry !== undefined) {
      const query = {
        QueryTypeID: OutboundQueryTypes.Country,
        Value: selectedCountry.code,
      };
      retVal.push(query);
    }
    for (const i in selectedStates) {
      const query = {
        QueryTypeID: OutboundQueryTypes.Location,
        Value: selectedStates[i].abbreviation,
      };
      retVal.push(query);
    }
    if (selectedFacility !== "" && selectedFacility !== undefined) {
      const query = {
        QueryTypeID: OutboundQueryTypes.Facility,
        Value: selectedFacility.id,
      };
      retVal.push(query);
    }
    if (selectedBrand !== "" && selectedBrand !== undefined) {
      const query = {
        QueryTypeID: OutboundQueryTypes.Brand,
        Value: selectedBrand.name,
      };
      retVal.push(query);
    }
    if (keyword !== "" && keyword !== undefined) {
      const query = { QueryTypeID: OutboundQueryTypes.Keyword, Value: keyword };
      retVal.push(query);
    }
    if (reqNumbers !== "" && reqNumbers !== undefined) {
      reqNumbers.split(", ").forEach((req) => {
        const query = {
          QueryTypeID: OutboundQueryTypes.ReqNumbers,
          Value: req,
        };
        retVal.push(query);
      });
    }
    return retVal;
  };

  const submitData = () => {
    if (checkAllEntered()) {
      setAddProcessing(true);
      addFeed(data).then((res) => {
        setShowSignifier(true);
        if (res) {
          getOutboundFeeds(selectedClient.id).then((response) => {
            for (const i in response) {
              response[i].dateCreated = convertDate(response[i].dateCreated);
              response[i].dateLastUpdated = convertDate(response[i].dateLastUpdated);
            }
            setData(response);
            openModal(false);
            setAddProcessing(false);
          });
        } else {
          setShowError(true);
        }
      });
    } else {
      setShowInputError(true);
    }
  };

  const data = {
    ClientId: selectedClient.id,
    TemplateId: selectedTemplate.id,
    Name: name,
    IsActive: isActive,
    UseCdata: useCData,
    OutboundClientFeedQueries: prepQueries(),
    OutboundClientFeedTrackingCodes: trackingCodes,
  };

  useEffect(() => {
    getAllFeedOptions(selectedClient.id).then((response) => {
      sort(response.outboundTemplates, "name");
      sort(response.categories, "name");
      sort(response.families, "name");
      sort(response.industries, "name");
      sort(response.countries, "name");
      sort(response.facilities, "name");
      setTemplates(response.outboundTemplates);
      setCategories(response.categories);
      setFamilies(response.families);
      setIndustries(response.industries);
      setCountries(response.countries);
      setFacilities(response.facilities);
      const convertToObject = response.brands.map(function (value) {
        return { name: value };
      });
      sort(convertToObject, "name");
      setBrands(convertToObject);
    });
  }, [selectedClient.id, sort]);

  useEffect(() => {
    if (!selectedCountry) return;

    for (const i in countries) {
      if (countries[i].name === selectedCountry.name) {
        getStates(countries[i].id).then((response) => {
          sort(response, "name");
          setStates(response);
          return;
        });
      }
    }
  }, [countries, selectedCountry, sort]);

  return (
    <div className={classes.root}>
      <LoadingBar loading={addProcessing} />
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <p>Add Outbound Feed</p>
              </Grid>
              <Grid xs={12} sm={6} item>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Name"
                  label="Name"
                  variant="standard"
                  fullWidth
                  required
                  value={name}
                  error={showInputError && name === ""}
                  className={classes.textField}
                  onChange={(e) => setName(e.target.value)}
                />
                {showInputError && name === "" && (
                  <FormHelperText className={classes.error}>Name Required</FormHelperText>
                )}
              </Grid>
              <Grid xs={12} sm={6} item>
                <DropdownComponent
                  currVal={selectedTemplate}
                  items={templates}
                  property="name"
                  title="Template"
                  handleChange={(value) => setSelectedTemplate(value)}
                  multi={false}
                  error={showInputError && selectedTemplate === ""}
                />
                {showInputError && selectedTemplate === "" && (
                  <FormHelperText className={classes.error}>Template Required</FormHelperText>
                )}
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={<Checkbox color="primary" checked={isActive} />}
                  onChange={() => setIsActive(!isActive)}
                  label="Active?"
                />
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={<Checkbox color="primary" checked={useCData} />}
                  onChange={() => setUseCData(!useCData)}
                  label="CDATA"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormHelperText
                  style={{
                    marginTop: "20px",
                    marginBottom: "-20px",
                    paddingTop: "10px",
                  }}
                >
                  Tracking Codes
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Button
                  style={{ marginTop: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => handleAddCode()}
                >
                  Add Code
                </Button>
              </Grid>

              <TrackingCodes trackingCodes={trackingCodes} setTrackingCodes={setTrackingCodes} />
              <Grid item xs={12} sm={12}>
                <FormHelperText style={{ marginTop: "20px", marginBottom: "-20px" }}>
                  Query Builder
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropdownComponent
                  currValue={selectedIndustry}
                  items={industries}
                  property="name"
                  title="Industries"
                  handleChange={(value) => setSelectedIndustry(value)}
                  multi={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropdownComponent
                  currValue={selectedFamily}
                  items={families}
                  property="name"
                  title="Families"
                  handleChange={(value) => setSelectedFamily(value)}
                  multi={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropdownComponent
                  currValue={selectedCategories}
                  items={categories}
                  property="name"
                  title="Categories"
                  handleChange={(value) => setSelectedCategories(value)}
                  multi={true}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownComponent
                  currValue={selectedCountry}
                  items={countries}
                  property="name"
                  title="Countries"
                  handleChange={(value) => setSelectedCountry(value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownComponent
                  currValue={selectedStates}
                  items={states}
                  property="name"
                  title="States"
                  handleChange={(value) => setSelectedStates(value)}
                  multi={true}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownComponent
                  currValue={selectedFacility}
                  items={facilities}
                  property="name"
                  title="Facilities"
                  handleChange={(value) => setSelectedFacility(value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownComponent
                  currValue={selectedBrand}
                  items={brands}
                  property="name"
                  title="Brands"
                  handleChange={(value) => setSelectedBrand(value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Keyword"
                  label="Keyword"
                  variant="standard"
                  fullWidth
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Requisition Numbers"
                  label="Requisition Numbers"
                  variant="standard"
                  fullWidth
                  value={reqNumbers}
                  onChange={(e) => setReqNumbers(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ color: "#82B288", marginTop: "20px" }}
                  type="submit"
                  variant="outlined"
                  disabled={addProcessing}
                  onClick={() => openModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginTop: "20px", marginLeft: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => submitData()}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
